<template>
  <attachment-list :delete-permission="'change_auction'" :change-permission="'change_auction'"
                   :object-uuid="sale.uuid" plural-object-name="auctions" object-name="auction"/>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import AttachmentList from "@/modules/attachments/AttachmentList";

  const {mapState} = createNamespacedHelpers('sales');

  export default {
    name: "Attachments",
    components: {AttachmentList},
    computed: {
      ...mapState({
        sale: state => state.view.currentSale
      }),
    }
  }
</script>

<style scoped>
</style>
